import type { FC, ReactNode } from 'react'

import { Home } from '@/ui/pages'

const Route: FC = (): ReactNode => <Home />

export default Route
